const initState = {
  loaded: true,
  data: [],
  error: [],
  messages: [],
  total: 0,
  message: {},
};
const socketReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_ROOMS_REQUEST":
      return {
        ...state,
        loaded: false,
      };
    case "FETCH_ROOMS_FAILURE":
      return {
        ...state,
        loaded: true,
        data: [],
        error: action.payload,
      };
    case "FETCH_ROOMS_SUCCESS":
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: [],
      };
    case "FETCH_MESSAGES_REQUEST":
      return {
        ...state,
        loaded: false,
      };
    case "FETCH_MESSAGES_FAILURE":
      return {
        ...state,
        loaded: true,
        messages: [],
        error: action.payload,
      };
    case "FETCH_MESSAGES_SUCCESS":
      return {
        ...state,
        loaded: true,
        messages: action.payload.messages,
        total: action.payload.total,
        error: [],
      };
    case "FETCH_PAGE_MESSAGES_FAILURE":
      return {
        ...state,
        error: action.payload,
      };
    case "FETCH_PAGE_MESSAGES_SUCCESS":
      const messages = [...action.payload.messages, ...state.messages];

      return {
        ...state,
        messages: messages
          .filter(
            (v, i, a) =>
              a.findIndex((t) => JSON.stringify(t) === JSON.stringify(v)) === i
          )
          .sort((a, b) => new Date(b.creationDate) - new Date(a.creationDate)),
        total: action.payload.total,
        error: [],
      };
    case "SET_MESSAGE":
      return {
        ...state,
        message: action.payload,
      };
    case "PUSH_MESSAGE":
      console.log(action.payload);
      return {
        ...state,
        messages: [action.payload, ...state.messages],
      };
    case "UPDATE_MESSAGE":
      const updatedMessages = [];

      state.messages.forEach((msg) => {
        if (msg._id === action.payload) {
          msg.state = 1;
          msg.likes = [];
        }
        updatedMessages.push(msg);
      });

      return {
        ...state,
        messages: updatedMessages,
      };
    case "EDIT_MESSAGE":
      const editedMessages = [];

      state.messages.forEach((msg) => {
        if (msg._id === action.payload.messageID) {
          msg.message = action.payload.message;
          msg.edited = true;
        }
        editedMessages.push(msg);
      });

      return {
        ...state,
        messages: editedMessages,
      };

    case "LIKE_MESSAGE":
      const likedMessages = [];

      state.messages.forEach((msg) => {
        if (msg._id === action.payload.messageID) {
          msg.likes = action.payload.likes;
        }
        likedMessages.push(msg);
      });

      return {
        ...state,
        messages: likedMessages,
      };
    default:
      return state;
  }
};

export default socketReducer;
